import { useEffect, useState } from 'react';
import styles from './pages.module.css';
import Card from '../../components/Card/Card';
import SportModul from '../../components/SportModul/SportModul';   // ⬅️ from the previous answer
import { fetchModulesByCategory } from '../../../code/SportModuleLoader';
import HeroBanner from '../../components/HeroBanner/HeroBanner';
const TurnTanz = () => {
    const [hasImages, setHasImages] = useState(false);
    const [modulesTurnen, setModuleTurnen] = useState([]);
    const [modulesTanzen, setModuleTanzen] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        fetchModulesByCategory('turnen', setModuleTurnen);
        fetchModulesByCategory('tanzen', setModuleTanzen);
        setLoading(false);
    }, []);
    if (loading) {
        return (
            <div></div>
        )
    }
    return (
        <div>
            <HeroBanner category="turn-und-tanz" onImagesLoaded={setHasImages} />
            <section
                className={styles.container}
                style={{ marginTop: hasImages ? '20px' : 'var(--marginTopDefault)' }}        >
                <h1>Turnen und Tanzen</h1>

                <div className={styles.startText}>
                    <p>In dieser neuen Abteilung haben wir unsere „alten“ Kinderturn- und Zumba-Angebote mit den neuen Tanzangeboten „Breakdance/Breaking“ sowie unserem Tanzabend „Standard tanzen“ zusammengeführt.</p>
                    <p> Ganz NEU, inspiriert von gemeinsam.gesellig.gesund, möchten wir auf das NEUE Para-Sport-Angebot für Kinder hinweisen, dass ab April in der TuS-Vereinshalle startet! Weitere Infos sind bei den Kacheln zu finden.</p>
                    <p>Wenn weitere Kindern den Kurs in Zukunft ergänzen und sich dadurch die Teilnehmerzahl erhöht, freuen wir uns, diesen Zusatzbeitrag streichen zu können.</p>
                </div>

                <section>
                    <h2>Turnen</h2>
                    <div className={styles.modulesContainer}>
                        {modulesTurnen.map((modul, index) => (
                            <Card
                                key={index}
                                id={modul.anchor_id}
                                icon={`${process.env.PUBLIC_URL}${modul.iconPath || modul.icon_path}`}
                                iconText={modul.iconText}
                                title={modul.title}
                                rightText={modul.class || ''}
                            >
                                <SportModul modul={modul} />
                            </Card>
                        ))}
                    </div>
                </section>
                <section>
                    <h2>Tanzen</h2>
                    <div className={styles.modulesContainer}>
                        {modulesTanzen.map((modul, index) => (
                            <Card
                                key={index}
                                icon={`${process.env.PUBLIC_URL}${modul.iconPath || modul.icon_path}`}
                                iconText={modul.iconText}
                                title={modul.title}
                                rightText={modul.class || ''}
                            >
                                <SportModul modul={modul} />
                            </Card>
                        ))}
                    </div>
                </section>
            </section>
        </div>
    );
};

export default TurnTanz;
